/* eslint-disable camelcase */
export default {
  error_placing: 'Error placing kid: {0}',
  placement_disabled: 'Manual placement disabled',
  place_confirm_header: 'Are you sure?',
  place: 'Place',
  under: 'under',
  left_leg: '- left leg?',
  right_leg: '- right leg?',

  lowest_left: 'Lowest left',
  lowest_right: 'Lowest right',
  spillover_is_left: 'Your Spillover Leg is LEFT',
  spillover_is_right: 'Your Spillover Leg is RIGHT',
  lowest_pos: 'Lowest position {0}',
  back_to_me: 'Back to me',

  country_flags: {
    tooltip: 'Country: {0}',
    unknown_country: 'Unknown country'
  }
};
